/* eslint-disable no-unused-vars */
import React from "react"
import { useDispatch } from "react-redux"
import { Form, Formik } from "formik"
import * as Yup from "yup"
import dayjs from "dayjs"
import { Button, Card, CardContent, FormControl, Stack, TextField, Typography } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import { COLORS } from "../../utils"
import { showAlerts } from "../../actions/ProductionSteps/alerts"
import AlertsLayout from "./AlertsLayout"

const schema = Yup.object().shape({
	productionDay: Yup.string().required("Veuillez sélectionner un jour de production")
})

const AlertsPageFilter = () => {
	const dispatch = useDispatch()

	const handleFormSubmit = (values) => {
		dispatch(showAlerts(dayjs(values.productionDay).format("DD-MM-YYYY")))
	}

	return (
		<AlertsLayout>
			<div className="flexColumn flex1 stretchSelf center justifyCenter">
				<Card sx={{ padding: "20px 15px", border: `1px solid ${COLORS.PRIMARY_BORDER}` }}>
					<CardContent className="flexColumn center">
						<Stack spacing={4} alignItems="center">
							<Typography gutterBottom variant="h6">
								Sélectionnez le jour de production
							</Typography>
							<Formik
								validationSchema={schema}
								initialValues={{
									productionDay: dayjs.utc().valueOf(),
								}}
								onSubmit={handleFormSubmit}
							>
								{({
									values,
									setFieldValue,
									handleSubmit,
									isValid,
								}) => {
									return (
										<Form>
											<Stack spacing={4}>
												<FormControl>
													<DatePicker
														disableCloseOnSelect={false}
														showToolbar={false}
														value={values.productionDay}
														name="productionDay"
														variant="inline"
														inputFormat="DD/MM/YYYY"
														required
														onChange={val => {
															setFieldValue("productionDay", dayjs.utc(val).valueOf())
														}}
														renderInput={(params) => <TextField {...params} variant="standard" label="Jour de production" />}
													/>
												</FormControl>
												<Button
													variant="contained"
													color="primary"
													type="submit"
													onClick={handleSubmit}
													disabled={!isValid}
												>
													VOIR LES ALERTES
												</Button>
											</Stack>
										</Form>
									)
								}}
							</Formik>
						</Stack>
					</CardContent>
				</Card>
			</div>
		</AlertsLayout>
	)
}
export default AlertsPageFilter

